import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslationKey, useTranslator } from '@Localization';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement, SyntheticEvent } from 'react';
import { FilterTabType } from '../../imageFilters.model';

interface IProps {
  disabled?: boolean;
  filterType: FilterTabType;
  labelKey: TranslationKey;
  count: number;
  showClear: boolean;
  isSelected: boolean;
  onSelect(filterType: FilterTabType): void;
  onClear(): void;
}

export const FilterHeader = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const handleClearClick = (e: SyntheticEvent): void => {
    e.stopPropagation();
    props.onClear();
  };

  const handleClick = (): void => {
    if (props.disabled) {
      return;
    }
    props.onSelect(props.filterType);
  };

  return (
    <div
      onClick={handleClick}
      title={props.disabled ? t('you_do_not_have_permissions_to_use_this_filter') : ''}
      className={classNames({ 'image-filter-header': true, selected: props.isSelected, disabled: props.disabled })}
    >
      <span className='label'>
        {t(props.labelKey)} {props.count > 0 && <>({props.count})</>}
      </span>
      {props.showClear && (
        <span
          onClick={handleClearClick}
          className='clear-button'
        >
          <FontAwesomeIcon icon={faTimes} />
        </span>
      )}
    </div>
  );
});
